(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ah-quote"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('ah-quotes')) return;

    customElements.define('ah-quotes', class extends HTMLElement {
      connectedCallback() {
        var all = Array.prototype.slice.call(this.querySelectorAll('.ah-quotes__item'));
        var real = all.filter(function (el) { return !el.classList.contains('ah-quotes__item--legacy'); });
        this.items = real.length ? real : all;
        if (!this.items.length) return;

        this.index = 0;
        this.paused = false;
        this.show(0);
        if (this.items.length < 2) return;

        this.buildDots();
        this.delay = Math.max(3000, Number(this.dataset.interval) || 6000);
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        var self = this;
        this._pause = function () { self.paused = true; };
        this._resume = function () { self.paused = false; };
        this.addEventListener('mouseenter', this._pause);
        this.addEventListener('mouseleave', this._resume);
        this.addEventListener('focusin', this._pause);
        this.addEventListener('focusout', this._resume);

        /* Éditeur de thème : sélectionner un avis l'affiche et fige le défilement. */
        this._select = function (e) {
          var i = self.items.indexOf(e.target.closest('.ah-quotes__item'));
          if (i >= 0) { self.show(i); self.paused = true; }
        };
        this.addEventListener('shopify:block:select', this._select);
        this.addEventListener('shopify:block:deselect', this._resume);

        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      start() {
        this.stop();
        if (this.reduced || this.items.length < 2) return;
        var self = this;
        this.timer = window.setInterval(function () {
          if (!self.paused && !document.hidden) self.show(self.index + 1);
        }, this.delay);
      }

      stop() {
        if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
      }

      show(n) {
        var len = this.items.length;
        this.index = ((n % len) + len) % len;
        for (var i = 0; i < len; i++) {
          this.items[i].classList.toggle('is-active', i === this.index);
        }
        if (this.dots) {
          for (var j = 0; j < this.dots.length; j++) {
            this.dots[j].setAttribute('aria-current', j === this.index ? 'true' : 'false');
          }
        }
      }

      buildDots() {
        var nav = document.createElement('div');
        nav.className = 'ah-quotes__dots';
        var self = this;
        this.dots = this.items.map(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ah-quotes__dot';
          b.setAttribute('aria-label', 'Avis ' + (i + 1) + ' sur ' + self.items.length);
          b.addEventListener('click', function () { self.show(i); self.start(); });
          nav.appendChild(b);
          return b;
        });
        this.appendChild(nav);
        this.show(this.index);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
